<div class="product-list-table">
    <div class="table-container">
        <mat-spinner *ngIf="dataLoading" class="loading-spinner" [diameter]="70"></mat-spinner>
        <table mat-table *ngIf="!dataLoading && dataSource.data" [dataSource]="dataSource">
            <ng-container matColumnDef="{{ col.key }}" *ngFor="let col of tableColumns; trackBy: trackByKey">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-container">
                        <span class="header-title">{{ col.value || col.key }}</span>

                        <div class="search-container" *ngIf="showInput">
                            <ng-container *ngIf="col.key === 'status'; else showInput">
                                <select
                                    class="search-input"
                                    [value]="getFilterValue(col.key)"
                                    (change)="applyColumnFilter($event, col.key)"
                                >
                                    <option value="">All</option>
                                    <option value="active">{{ SupportSessionStatuses.Active }}</option>
                                    <option value="queued">{{ SupportSessionStatuses.Queued }}</option>
                                    <option value="closed">{{ SupportSessionStatuses.Closed }}</option>
                                </select>
                            </ng-container>

                            <ng-template #showInput>
                                <input
                                    type="text"
                                    class="search-input"
                                    [value]="getFilterValue(col.key)"
                                    (input)="applyColumnFilter($event, col.key)"
                                    [disabled]="col.key === 'messages'"
                                />
                            </ng-template>
                        </div>
                    </div>
                </th>
                <td
                    mat-cell
                    #tdElement
                    class="table-data-cell hide-overflow"
                    [matTooltip]="
                        col.type === 'datetime'
                            ? (getValue(row, col.key) | date: 'dd/MM/yyyy hh:mm:ss a')
                            : col.tooltipKey
                            ? getValue(row, col.tooltipKey)
                            : getValue(row, col.key)
                    "
                    [matTooltipDisabled]="!isOverflow(tdElement)"
                    [matTooltipShowDelay]="500"
                    [matTooltipHideDelay]="500"
                    matTooltipPosition="above"
                    matTooltipClass="tooltip"
                    *matCellDef="let row"
                    [ngSwitch]="col.type"
                >
                    <ng-container *ngSwitchCase="'checkbox'">
                        <mat-checkbox
                            (change)="$event ? handleCheckboxChange(row.id, $event) : null"
                            [checked]="isSelected(row.id)"
                        ></mat-checkbox>
                    </ng-container>

                    <!-- <ng-container *ngSwitchCase="'action'">
                        <div class="actions" *ngIf="actions?.length">
                            <mat-icon
                                class="actions-icon"
                                matTooltip="{{ action.label }}"
                                [matTooltipShowDelay]="500"
                                [matTooltipHideDelay]="500"
                                matTooltipPosition="above"
                                matTooltipClass="iconTooltip"
                                (click)="onActionClick(action, row.id)"
                                *ngFor="let action of actions"
                                >{{ action.icon }}</mat-icon
                            >
                        </div>
                    </ng-container> -->

                    <ng-container *ngSwitchCase="'action'">
                        <div class="actions" *ngIf="getVisibleActions(row)?.length">
                            <!-- Three dots icon to trigger the menu -->
                            <mat-icon class="actions-icon" [matMenuTriggerFor]="menu"> more_horiz </mat-icon>

                            <!-- Menu for actions -->
                            <mat-menu #menu="matMenu">
                                <button
                                    mat-menu-item
                                    *ngFor="let action of getVisibleActions(row)"
                                    (click)="onActionClick(action, row.id)"
                                >
                                    <mat-icon>{{ action.icon }}</mat-icon>
                                    {{ action.label }}
                                </button>
                            </mat-menu>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'image'">
                        <img src="{{ row[col.key] }}" alt="" />
                    </ng-container>

                    <ng-container *ngSwitchCase="'thumbnail'">
                        <img src="{{ (row[col.key]?.imagesUrl)[0] }}" class="thumbnail-image" alt="" />
                    </ng-container>

                    <ng-container *ngSwitchCase="'imagesGallery'">
                        <div
                            class="image-content"
                            *ngIf="row[col.key]?.imagesUrl?.length"
                            (click)="onClickImage(row[col.key]?.imagesUrl)"
                        >
                            <img class="image" src="{{ (row[col.key]?.imagesUrl)[0] }}" alt="" />
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'price'"> {{ config.currency }} {{ row[col.key] }} </ng-container>

                    <ng-container *ngSwitchCase="'percent'"> {{ row[col.key] }} {{ "%" }} </ng-container>

                    <ng-container *ngSwitchCase="'datetime'">
                        <ng-container *ngIf="col.key === 'updatedAt' && shouldDisplayUpdatedAt(row)">
                            {{ row[col.key] | date: "dd/MM/yyyy hh:mm:ss a" }}
                        </ng-container>
                        <ng-container *ngIf="col.key === 'validUpTo'">
                            {{ row[col.key] | date: "dd/MM/yyyy" }}
                        </ng-container>
                        <ng-container *ngIf="col.key !== 'updatedAt' && col.key !== 'validUpTo'">
                            {{ row[col.key] | date: "dd/MM/yyyy hh:mm:ss a" }}
                        </ng-container>
                    </ng-container>

                    <ng-container *ngSwitchCase="'button'">
                        <ng-container *ngIf="row[col.key] === reviewStatus.Pending; else viewMessage">
                            <button class="save-btn" mat-stroked-button (click)="onStatusButtonClick(row)">
                                {{ row[col.key] }}
                            </button>
                        </ng-container>
                        <ng-template #viewMessage>
                            <ng-container *ngIf="row.messages?.length > 0; else showText">
                                <button class="save-btn" mat-stroked-button (click)="viewChat(row)">View Chat</button>
                            </ng-container>

                            <ng-template #showText>
                                <span>{{ row[col.key] }}</span>
                            </ng-template>
                        </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                        <div class="reduce-text-content">
                            {{ getValue(row, col.key) }}
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'toggle'">
                        <mat-slide-toggle
                            [checked]="row[col.key]"
                            (change)="onToggleChange($event, row)"
                        ></mat-slide-toggle>
                    </ng-container>

                    <ng-container *ngSwitchCase="'text'">
                        <ng-container *ngIf="col.key === 'status'">
                            {{ row[col.key] }}
                        </ng-container>
                        <ng-container *ngIf="col.key !== 'status'">
                            {{ getValue(row, col.key) }}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>

            <tr mat-header-row class="table-header-row" *matHeaderRowDef="getColumnProps('key'); sticky: true"></tr>

            <tr mat-row class="table-data-row" *matRowDef="let row; columns: getColumnProps('key')"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell empty-td" [attr.colspan]="tableColumns && tableColumns.length" *ngIf="!dataLoading">
                    {{ "noDataFound" | translate }}
                </td>
            </tr>
        </table>
    </div>
    <mat-paginator
        #paginator
        *ngIf="showPaginator"
        [length]="dataTableSize"
        [pageIndex]="config.pageIndex"
        [pageSize]="config.pageSizeOptions![0]"
        [pageSizeOptions]="config.pageSizeOptions!"
        (page)="onPageChange($event)"
        showFirstLastButtons
    >
    </mat-paginator>
</div>
